import { AlgorithmCardType } from '../../shared/types.js';

export interface AlgorithmCardVisual {
  url: string;
  accentColor: string;
}

export const ALGORITHM_CARD_VISUALS: Record<AlgorithmCardType, AlgorithmCardVisual> = {
  [AlgorithmCardType.Regroup]: {
    url: new URL('../assets/cards/regroup.png', import.meta.url).href,
    accentColor: '#7df7ff',
  },
  [AlgorithmCardType.Scatter]: {
    url: new URL('../assets/cards/scatter.png', import.meta.url).href,
    accentColor: '#ff5bd6',
  },
  [AlgorithmCardType.Follow]: {
    url: new URL('../assets/cards/follow.png', import.meta.url).href,
    accentColor: '#5cc8ff',
  },
  [AlgorithmCardType.Orbit]: {
    url: new URL('../assets/cards/orbit.png', import.meta.url).href,
    accentColor: '#8c7dff',
  },
  [AlgorithmCardType.DefensiveWall]: {
    url: new URL('../assets/cards/defensive-wall.png', import.meta.url).href,
    accentColor: '#ffbf4a',
  },
  [AlgorithmCardType.RadarRing]: {
    url: new URL('../assets/cards/radar-ring.png', import.meta.url).href,
    accentColor: '#59ffb2',
  },
  [AlgorithmCardType.FocusFire]: {
    url: new URL('../assets/cards/focus-fire.png', import.meta.url).href,
    accentColor: '#ff4f57',
  },
  [AlgorithmCardType.RelayNet]: {
    url: new URL('../assets/cards/relay-net.png', import.meta.url).href,
    accentColor: '#b26cff',
  },
  [AlgorithmCardType.CageSurround]: {
    url: new URL('../assets/cards/cage-surround.png', import.meta.url).href,
    accentColor: '#ffbf4a',
  },
  [AlgorithmCardType.SyncDive]: {
    url: new URL('../assets/cards/sync-dive.png', import.meta.url).href,
    accentColor: '#5aa7ff',
  },
  [AlgorithmCardType.ConvertShot]: {
    url: new URL('../assets/cards/convert-shot.png', import.meta.url).href,
    accentColor: '#ff5b7d',
  },
  [AlgorithmCardType.ChoreoUltimate]: {
    url: new URL('../assets/cards/choreo-ultimate.png', import.meta.url).href,
    accentColor: '#ffd15a',
  },
  [AlgorithmCardType.HorizontalOrbit]: {
    url: new URL('../assets/cards/horizontal-orbit.png', import.meta.url).href,
    accentColor: '#5fdfff',
  },
  [AlgorithmCardType.DiagonalOrbit]: {
    url: new URL('../assets/cards/diagonal-orbit.png', import.meta.url).href,
    accentColor: '#b26cff',
  },
};

export function getAlgorithmCardVisual(cardType: number): AlgorithmCardVisual {
  return ALGORITHM_CARD_VISUALS[cardType as AlgorithmCardType] ?? ALGORITHM_CARD_VISUALS[AlgorithmCardType.Regroup];
}
